// This file was auto-generated by Fern from our API Definition.
export const Format = {
    Agenta: "agenta",
    Opentelemetry: "opentelemetry",
};
